import { Invoice } from "../../../buy/services/invoice.model";
import { PackageThumbnail, PriceDetails, PromocodeResponse, UserListeningPackagesResponse } from "../../../common/services/package/package.model";
import GlobalSpinnerService from "../../../common/services/spinner/global-spinner.service";
import angular = require("angular");
import { Action } from "../../../common/actions/core/action";
import { NoAuthBillInfoAddAction } from "../../components/bill-info-add/bill-info-add.action";
import { NoAuthBillInfoChangeAction } from "../../components/actions/bill-info-change.action";
import ActionDispatcherService from "../../../common/actions/core/action-dispatcher.service";
import { GoToOffersAction } from "../../components/go-to-offers-dialog/go-to-offers-dialog.action";
import ActionAwareController from "../../../common/actions/action-aware.controller";
import { DistantSaleAction } from "../../../common/actions/distant-sale-action";
import { PreInfoSaleAction } from "../../../common/actions/pre-info-action";
import { NoAuthOpenDistantSalesAggreementAction } from "../../components/distant-sales-dialog/distant-sales-dialog.action";
import { NoAuthOpenPreInfoFormAction } from "../../components/pre-info-form-dialog/pre-info-form-dialog.action";
import { ContractApproveAction } from "../../../common/actions/contract-approve-action";
import UserInfoService from "../../services/user-info.service";
import NotificationService from "../../../common/services/notification/notification.service";

export default class ValidController extends ActionAwareController {
  private msisdn;
  private valid: boolean;
  private packet: PackageThumbnail;

  private packages: UserListeningPackagesResponse;
  private invoice: Invoice;
  private discount: PromocodeResponse;
  public promocode: string;

  private initiated = false;
  private invoiceValid = false;
  private offerable = true;

  public priceDetails: PriceDetails;
  private packetPrice: string;


  constructor(
    private $translate,
    private $sce,
    private $stateParams,
    private $location,
    private globalSpinner: GlobalSpinnerService,
    private notificationService: NotificationService,
    actionDispatcher: ActionDispatcherService,
    private userInfoService: UserInfoService
  ) {
    super(actionDispatcher);
  }


  public $onInit() {
    if (angular.isUndefined(this.packet) || angular.isUndefined(this.msisdn)) {
      return;
    }
    super.$onInit();

    if (!!this.$stateParams.promocode) {
      sessionStorage.setItem('promocode', this.$stateParams.promocode);
      this.$location.search('promocode', null);
    } else if (!!sessionStorage.getItem('promocode')) {
      this.promocode = sessionStorage.getItem('promocode');
      sessionStorage.removeItem('promocode');
    }

    this.initiateUserInfo();
    this.loadTranslations();
  }

  public handle(action: Action) {
    if (action instanceof NoAuthBillInfoChangeAction) {
      this.invoice = action.invoice;
    }

    if (action instanceof NoAuthBillInfoAddAction) {
      var names = ['#firstName', '#lastName', '#e-mail'];
      for (var i = 0; i < names.length; i++) {
        var elem = document.querySelector(names[i]) as HTMLElement;
        if (elem.getAttribute('aria-invalid') === 'true') {
          elem.focus();
          break;
        }
      }
    }

    if (action instanceof DistantSaleAction) {
      this.globalSpinner.startIfNotActivated();
      this.actionDispatcher.dispatch(
        new NoAuthOpenDistantSalesAggreementAction(
          this.msisdn,
          () => this.approveDistantSale(),
          action.type,
          this.packet.id,
          action.paymentType
        )
      );
    }

    if (action instanceof PreInfoSaleAction) {
      this.globalSpinner.startIfNotActivated();
      this.actionDispatcher.dispatch(
        new NoAuthOpenPreInfoFormAction(this.msisdn, () => this.approvePreInfo(), this.packet.id, action.paymentType)
      );
    }
  }

  private async initiateUserInfo() {
    if (!this.initiated) {
      this.globalSpinner.startIfNotActivated();

      await this.userInfoService.initiateAllUserInfo(this.msisdn, (key) => this.showWarning(key));
      var offerable = this.userInfoService.checkOfferables(this.packet.id);
      this.globalSpinner.stop();
      if (offerable === "") {
        this.valid = true;
      } else {
        this.offerable = false;
        this.actionDispatcher.dispatch(new GoToOffersAction(this.msisdn, offerable));
      }
      this.updateUserInfo();
    }
  }

  private updateUserInfo() {
    this.packages = this.userInfoService.getPackages();
    this.invoice = this.userInfoService.getInvoice();
    if (!!this.invoice) {
      this.invoiceValid = true;
    }
    this.initiated = true;
  }

  private loadTranslations() {
    var translateKey =
      !this.priceDetails ||
        !this.priceDetails.pricePeriod ||
        this.priceDetails.pricePeriod === 'monthly'
        ? 'packet.period'
        : 'packet.periodYear';
    this.$translate(translateKey, this.packet).then(value => {
      this.packetPrice = this.$sce.trustAsHtml(value);
    });
  }

  private showWarning(translateKey: string) {
    translateKey = (translateKey === "") ? 'error.message.default' : translateKey;
    this.$translate(translateKey).then(value => {
      this.notificationService.showNotification({
        text: value,
        type: 'warning'
      });
    });
  }

  private approveDistantSale() {
    this.actionDispatcher.dispatch(
      new ContractApproveAction({
        distantAggreement: true
      })
    );
  }

  private approvePreInfo() {
    this.actionDispatcher.dispatch(
      new ContractApproveAction({
        preInfoAggreement: true
      })
    );
  }
}


// WEBPACK FOOTER //
// src/app/no-auth/buy/valid/valid.controller.ts